module.exports = __webpack_public_path__ + "static/VTFMisterPixel-Tools-80d5291cb1b2f9f813367b7fcac8a9c8.svg";